<nav class="dashboard-actions" [attr.aria-label]="'SIDEBAR.HOME' | translate">
    <a class="dashboard-action" [routerLink]="createRoute">
        <span class="dashboard-action-icon"><i class="fal fa-calendar-plus" aria-hidden="true"></i></span>
        <span class="dashboard-action-label">{{ 'SIDEBAR.TAN-CREATE' | translate }}</span>
        <i class="fal fa-arrow-right dashboard-action-arrow" aria-hidden="true"></i>
    </a>
    <a class="dashboard-action" [routerLink]="overviewRoute">
        <span class="dashboard-action-icon"><i class="fal fa-calendar-alt" aria-hidden="true"></i></span>
        <span class="dashboard-action-label">{{ 'SIDEBAR.OVERVIEW' | translate }}</span>
        <i class="fal fa-arrow-right dashboard-action-arrow" aria-hidden="true"></i>
    </a>
    <a class="dashboard-action" [routerLink]="requestsRoute">
        <span class="dashboard-action-icon"><i class="fal fa-inbox-in" aria-hidden="true"></i></span>
        <span class="dashboard-action-label">{{ 'APPOINTMENT-OVERVIEW.TAB.REQUESTS' | translate }}</span>
        @if ((openRequests$ | async); as count) {
            <span class="dashboard-action-badge">{{ count }}</span>
        } @else {
            <i class="fal fa-arrow-right dashboard-action-arrow" aria-hidden="true"></i>
        }
    </a>
</nav>

<section class="dashboard-hero">
    <div class="dashboard-hero-text">
        <h2>{{ 'DASHBOARD.NEWS.TITLE' | translate}}</h2>
        <p>{{ 'DASHBOARD.NEWS.BODY.PART-1' | translate}}</p>
        <p>{{ 'DASHBOARD.NEWS.BODY.PART-2' | translate}}</p>
        <p>{{ 'DASHBOARD.NEWS.BODY.PART-3' | translate}}</p>
        <a class="btn dashboard-hero-cta" [routerLink]="settingsRoute">{{ 'DASHBOARD.NEWS.CTA' | translate }}</a>
    </div>
    <img class="dashboard-hero-illustration" src="/assets/img/illustrations/image-upload-dashboard.png" alt="">
</section>


<section class="dashboard-grid">
    <div class="dashboard-card dashboard-card-tours">
        <h3>{{ 'DASHBOARD.UPDATES.HEADER' | translate}}</h3>
        <p>{{ 'DASHBOARD.UPDATES.BODY' | translate}}</p>
    </div>
    <div class="dashboard-card dashboard-card-feedback">
        <h4>{{ 'DASHBOARD.FEEDBACK.TITLE' | translate}}</h4>
        <p>
            {{ 'DASHBOARD.FEEDBACK.BODY' | translate}}
            <a (click)="showFeedbackSurvey()" (keydown.enter)="showFeedbackSurvey()" tabindex="0" role="button">{{ 'DASHBOARD.FEEDBACK.URL' | translate}}
                <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
        </p>
    </div>
</section>
